import { useState } from 'react';

import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  Typography,
} from '@mui/material';

import { Helmet } from 'react-helmet-async';

import ChangePasswordConfirmation from './ChangeForm';
import FormStyle from '../FormStyle';
import showTableData from '../Functions/showTableData';
import ChangedPasswordWithSuccess from './ChangedPasswordWithSuccess';

function ChangePasswordIndex() {
  // variables
  const [changedSuccessfully, setChangedSuccessfully] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // functions
  const handleChangePassword = () => {
    setIsEditing(!isEditing);
  };

  // render conditions
  if (isEditing) {
    return (
      <ChangePasswordConfirmation setChangedPasswordSucessfully={setChangedSuccessfully} setIsEditing={setIsEditing} />
    );
  }

  if (changedSuccessfully) {
    return (
      <ChangedPasswordWithSuccess
        setChangedPasswordSucessfully={setChangedSuccessfully}
        setIsEditing={setIsEditing}
      />
    );
  }

  return (
    <div className="main">
      <Helmet>
        <title>Password</title>
      </Helmet>
      <main
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 65px)',
        }}
      >
        <Box className="container-fluid my-1">
          <Box sx={FormStyle.previewHeader}>
            <h1 className="text-bold">Password</h1>
            Change your registered password here
          </Box>
          <Box className="card">
            <Box className="card-body">
              <Grid
                container
                justifyContent="center"
              >
                <Grid item xs={12}>
                  <Table className="table-form-setting">
                    <TableBody>
                      {showTableData({
                        ticket: 'Current password',
                        value: '●●●●●●●●',
                      })}
                    </TableBody>
                  </Table>
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <Typography
                    fontSize={12}
                    color="gray"
                  >
                    *For security, the password is masked and displayed with a different number of digits.
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleChangePassword}
                    variant="contained"
                    className="mt-3"
                  >
                    Change password
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}
export default ChangePasswordIndex;
